import { render } from "./SalaryItemsBranchesPage.vue?vue&type=template&id=0075bacc&scoped=true"
import script from "./SalaryItemsBranchesPage.vue?vue&type=script&lang=js"
export * from "./SalaryItemsBranchesPage.vue?vue&type=script&lang=js"

import "./SalaryItemsBranchesPage.vue?vue&type=style&index=0&id=0075bacc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0075bacc"]])

export default __exports__